import SucKhoeHocSinhPage from "./SucKhoeHocSinhPage";
import SucKhoeModal from "./SucKhoeModal";

export default SucKhoeHocSinhPage;
export { SucKhoeModal };